import { apiSlice } from '../../api/apiSlice';
import { GET_COACHING_ACTION, GET_COACHING_BEHAVIOR, GET_COACHING_SKILL } from '../../constants';

export const CoreValueDropdownSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getCoachingSkill : builder.query({
            query: (args : any) => {
                const { employeeNumber } = args;
                return {
                    url: GET_COACHING_SKILL,
                    params: { employeeNumber },
                };
            },
            keepUnusedDataFor: 300,  // Cache for 5 minutes (300 seconds)
        }),
        getCoachingBehaviorById: builder.query({
            query: (args : any) => {
                const {coachingSkillId, employeeNumber} = args; 
                return {
                    url: GET_COACHING_BEHAVIOR,
                    params: {coachingSkillId, employeeNumber},
                };
            },
            keepUnusedDataFor: 300,  // Cache for 5 minutes (300 seconds)
        }),
        getCoachingAction: builder.query({
            query: (args : any) => {
                const { employeeNumber,coachingBehaviorId } = args;
                return {
                    url: GET_COACHING_ACTION,
                    params: { employeeNumber,coachingBehaviorId },
                };
            },
            keepUnusedDataFor: 300,  // Cache for 5 minutes (300 seconds)
        }),
    }),
});

export const { 
    useGetCoachingSkillQuery,
    useGetCoachingBehaviorByIdQuery,
    useGetCoachingActionQuery,
  } = CoreValueDropdownSlice;
